<template>
  <div>
    <EmployeeHeader title="Nuevo Empleado"/>
    <hr>
    <EmployeeForm :employee="employee" @onCreate="onCreate"/>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import EmployeeHeader from '../EmployeeHeader'
import EmployeeForm from '../EmployeeForm'

export default {
  name: 'EmployeeNew',
  components: { EmployeeHeader, EmployeeForm },
  data () {
    return {
      employee: {
        name: '',
        surname: '',
        phone: ''
      }
    }
  },
  computed: {
    ...mapGetters([
      'userId'
    ])
  },
  methods: {
    ...mapMutations([
      'toggleEmployeeBtnLoading'
    ]),
    ...mapActions([
      'createEmployee',
      'setAlertData',
      'isProductBtnLoading'
    ]),
    onCreate (data) {
      this.toggleEmployeeBtnLoading(true)
      data.createdAt = new Date().getTime()
      this.createEmployee(data)
        .then((res) => {
          this.toggleEmployeeBtnLoading(false)
          this.$router.push({ name: 'Employees' })
          this.setAlertData({
            visible: true,
            msg: 'Empleado creado ;)',
            type: 'success'
          })
        })
        .catch((err) => {
          this.toggleEmployeeBtnLoading(false)
          console.log('[onCreateEmployee]')
          console.log(err.toString())
        })
    }
  }
}
</script>
